import { render, staticRenderFns } from "./BoxContainer.vue?vue&type=template&id=4398c58a&scoped=true&"
import script from "./BoxContainer.vue?vue&type=script&lang=js&"
export * from "./BoxContainer.vue?vue&type=script&lang=js&"
import style0 from "./BoxContainer.vue?vue&type=style&index=0&id=4398c58a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4398c58a",
  null
  
)

export default component.exports